// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-number .icon{font-size:18px}.input-number.error--text .v-text-field__details{white-space:nowrap;overflow:visible}", ""]);
// Exports
module.exports = exports;
